var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf03W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 18,
    height: 22,
    transform: "translate(199.986 254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(-184.486 -240)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M217.637,265.385a3.292,3.292,0,0,0-3.517-3.436c-3.515,0-7.028,0-10.542,0-.821,0-1.362-.447-1.354-1.092s.511-1.044,1.317-1.052c1.184-.01,2.37.009,3.557-.008.559-.007,1.349.251,1.619-.113.285-.387.08-1.119.1-1.7.01-.257-.039-.388-.351-.384-1.8.021-3.6-.04-5.4.049a3.171,3.171,0,0,0-3.065,3.2q-.038,5.967,0,11.935A3.241,3.241,0,0,0,203,276h11.641a3.267,3.267,0,0,0,3-3.35q.021-3.631,0-7.264Zm-6.1,5.21c-.344-.005-.516-.055-.5-.453.03-.777.026-1.556,0-2.332-.012-.347.105-.424.442-.432,1.707-.04,1.707-.049,1.707,1.641S213.185,270.624,211.533,270.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M215.412,258.023c0,.951-.016,1.7.008,2.443.011.339-.093.43-.44.438-1.794.047-1.794.058-1.794-1.707v-.969c-.484.2-.78.932-1.056.807a6.389,6.389,0,0,1-1.4-1.233c-.185-.167-.112-.266.029-.4,1.1-1.081,2.211-2.162,3.3-3.258.218-.22.333-.157.512.02,1.081,1.076,2.163,2.149,3.26,3.208.209.2.2.319,0,.506a9.755,9.755,0,0,0-.974.965c-.283.337-.479.264-.716-.029-.184-.229-.4-.434-.726-.787Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf03W);
export default __webpack_public_path__ + "static/media/icon-wf-03-w.4e819fb3e67a56ea95df16b238bed4bf.svg";
export { ForwardRef as ReactComponent };